<template>
  <AuthShell
    title="Recupera password"
    subtitle="Inserisci la tua email: ti invieremo le istruzioni per reimpostare la password."
  >
    <div
      v-if="sent"
      class="rounded-lg bg-gray-50 border border-gray-200 px-4 py-3 text-sm text-gray-600 text-center"
    >
      Se l'indirizzo è registrato, riceverai un'email con le istruzioni per reimpostare la password.
    </div>

    <form v-else @submit.prevent="submit" novalidate class="space-y-4">
      <div>
        <label class="block text-sm font-medium text-gray-600 mb-1" for="email">Email</label>
        <input
          id="email"
          v-model="email"
          type="email"
          autocomplete="email"
          required
          :disabled="loading"
          placeholder="nome@esempio.it"
          class="w-full px-3 py-2 text-sm text-gray-800 border border-gray-300 rounded-lg placeholder-gray-400 focus:outline-none focus:border-onibble focus:ring-2 focus:ring-onibble transition"
        />
      </div>

      <p v-if="errorMsg" class="text-sm text-red-500">{{ errorMsg }}</p>

      <button
        type="submit"
        :disabled="loading"
        class="w-full py-2.5 px-4 text-sm font-semibold text-gray-900 bg-ynibble rounded-lg shadow-sm hover:bg-onibble focus:outline-none focus:ring-2 focus:ring-onibble disabled:opacity-60 transition-colors"
      >
        <span v-if="loading">Invio in corso…</span>
        <span v-else>Invia istruzioni</span>
      </button>
    </form>

    <div class="mt-6 text-center">
      <router-link to="/login" class="text-sm font-medium text-onibble hover:text-ynibble transition-colors">
        ← Torna al login
      </router-link>
    </div>
  </AuthShell>
</template>

<script>
import { forgotPassword } from '@/plugins/sessionAuth.js';
import AuthShell from './AuthShell.vue';

export default {
  name: 'ForgotPasswordView',
  components: { AuthShell },
  data() {
    return {
      email: '',
      loading: false,
      errorMsg: '',
      sent: false,
    };
  },
  methods: {
    async submit() {
      this.errorMsg = '';
      this.loading = true;
      try {
        await forgotPassword(this.email);
        this.sent = true;
      } catch (e) {
        this.errorMsg = e.message || 'Richiesta fallita. Riprova.';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
